import MpdText from './MpdText.vue'

export default MpdText
